import { render, staticRenderFns } from "./UserAddressManager.vue?vue&type=template&id=6d5ec842&scoped=true&"
import script from "./UserAddressManager.vue?vue&type=script&lang=js&"
export * from "./UserAddressManager.vue?vue&type=script&lang=js&"
import style0 from "./UserAddressManager.vue?vue&type=style&index=0&id=6d5ec842&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5ec842",
  null
  
)

export default component.exports